enum GraphicDataSort {
    None = 0,
    ValueAsc = 1,
    ValueDesc = 2,
    LabelAsc = 3,
    LabelDesc = 4
}

export default GraphicDataSort;